import { nectarApi } from '@/features/nectar/api/client'
import { parseMoney } from '@/utils'
import { useQuery, type UseQueryResult } from '@tanstack/react-query'

type UserBalanceWire = {
  availableUsd: string
  pendingUsd: string
  totalEarnedUsd: string
}

export type UserBalance = {
  availableUsd: number
  pendingUsd: number
  totalEarnedUsd: number
}

export const useFetchUserBalance = (): UseQueryResult<UserBalance> => {
  return useQuery({
    queryKey: ['balance'],
    queryFn: async (): Promise<UserBalance> => {
      const wire = await nectarApi.get<UserBalanceWire>('/v1/user/balance')
      return {
        availableUsd: parseMoney(wire.availableUsd),
        pendingUsd: parseMoney(wire.pendingUsd),
        totalEarnedUsd: parseMoney(wire.totalEarnedUsd)
      }
    },
    staleTime: 60_000
  })
}
